import { render, staticRenderFns } from "./ProfileInfoItem.vue?vue&type=template&id=7c566f10&scoped=true&"
import script from "./ProfileInfoItem.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfoItem.vue?vue&type=style&index=0&id=7c566f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c566f10",
  null
  
)

export default component.exports